module.exports = __webpack_public_path__ + "static/media/ordersPage.8b60cb22.png";